import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { ChildOnboardingStore } from './+state/child-onboarding.store';
import { InvestmentStrategyStore } from './+state/investment-strategy.store';
import { OnboardingEffects } from './+state/onboarding.effects';
import { onboardingFeature } from './+state/onboarding.reducer';
import { ChildOnboardingStepService } from './application/child-onboarding-step/child-onboarding-step.service';

export const provideOnboardingDomain = () => {
  return [makeEnvironmentProviders([provideState(onboardingFeature), provideEffects(OnboardingEffects)])];
};

export const provideInvestmentStrategyStore = () => {
  return [makeEnvironmentProviders([InvestmentStrategyStore])];
};
export const provideChildOnboardingStore = () => {
  return [makeEnvironmentProviders([ChildOnboardingStore, ChildOnboardingStepService])];
};
